import React from 'react';
import { observer } from 'mobx-react-lite';

import './style.scss';

import { GameFrame } from '../../game-frame';

interface DefaultGameLaunchProps {
  frameNonce?: number;
  gameFrameSource: string,
  refCallback: React.Ref<HTMLIFrameElement>;
}

export const DefaultGameLaunch: React.FC<DefaultGameLaunchProps> = observer(({ gameFrameSource, refCallback, frameNonce }) => {
  return (
    <GameFrame frameSource={gameFrameSource} refCallback={refCallback} frameNonce={frameNonce} />
  );
});
